import { FETCH_COUNTRY_SUCCESS } from '../constants/ActionTypes';

export default function country(state = undefined, action) {
    switch (action.type) {
        case FETCH_COUNTRY_SUCCESS:
            return action.payload;
        default:
            return state;
    }
}
